import { Navigate } from "react-router-dom"
import { useAuth } from "~/AuthContext"
import { PageSpinner } from "~/components/Spinner"
import routes from "~/routes"

export default function Guarded({ children }) {
  const { user, loading } = useAuth()

  if (loading) return <PageSpinner />
  if (!user) return <Navigate to={routes.signIn} replace />

  return children
}
